import { FILTER_FORM_DEFAULT_VALUES } from '../../util/constants.js'

export function UPDATE_CONNECTIONS(state, data) {
  state.connections = data
}

export function CLEAR_CONNECTIONS(state) {
  state.connections = []
}

export function UPDATE_ORGANISATION_CONNECTIONS(state, data) {
  state.organisationConnections = data
}

export function CLEAR_ORGANISATION_CONNECTIONS(state) {
  state.organisationConnections = []
}

export function UPDATE_ORGANISATIONS(state, data) {
  state.organisations = data
}

export function CLEAR_ORGANISATIONS(state) {
  state.organisations = []
}

export function UPDATE_REPORTS(state, data) {
  state.reports = data
}

export function CLEAR_REPORTS(state) {
  state.reports = []
}

export function UPDATE_REPORTS_YEARS(state, data) {
  state.reportsYears = data
}

export function CLEAR_REPORTS_YEARS(state) {
  state.reportsYears = []
}

export function UPDATE_REPORTS_STATS(state, data) {
  state.reportsStats = data
}

export function CLEAR_REPORTS_STATS(state) {
  state.reportsStats = {}
}

export function UPDATE_REPORT_SELECTED_CONNECTIONS(state, data) {
  state.reportSelectedConnections = data
}

export function CLEAR_REPORT_SELECTED_CONNECTIONS(state) {
  state.reportSelectedConnections = []
}

// Could this be moved?
export function UPDATE_POST_SELECTED_CONNECTIONS(state, data) {
  state.postSelectedConnections = data
}

export function CLEAR_POST_SELECTED_CONNECTIONS(state) {
  state.postSelectedConnections = []
}

export function UPDATE_FILTER_FORM(state, data) {
  state.filterForm = data
}

export function CLEAR_FILTER_FORM(state) {
  state.filterForm = { ...FILTER_FORM_DEFAULT_VALUES }
}
